import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { loadWidgetCMP, changeWidgetJSProp } from '../actions';

import BGRAreasControls from './controls/BGRAreasControls';

function WidgetImageManipulations({ widget, ...props }) {
    return (
        <div>
            <h3>Override background</h3>
            <BGRAreasControls />
        </div>
    );
}

WidgetImageManipulations.propTypes = {};

const mapStateToProps = ({ editor, ...state }, props) => {
    return {
        widget: editor.widget,
    };
};

const mapDispatchToProps = { loadWidgetCMP, changeWidgetJSProp };

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    lifecycle({
        componentWillReceiveProps() {},
        componentDidMount() {},
    }),
)(WidgetImageManipulations);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/WidgetImageManipulations.js
 **/